/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesGCSEquipments.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for GCS Equipment Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, April 01, 2019 - 08:21:08 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      04/01/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const GCSEquipmentList = Loadable({
    loader: () => import('../containers/GCSEquipments/GCSEquipmentListContainer'),
    loading: Loading,
});

export const GCSEquipmentForm = Loadable({
    loader: () => import('../containers/GCSEquipments/GCSEquipmentEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesGCSEquipments.js